export enum HdGraphType {
	Barline = 'barline',
	Pie = 'pie',
	Funnel = 'funnel',
	Gauge = 'gauge',
	Treemap = 'treemap',
	Sankey = 'sankey',
	Scatter = 'scatter',
	Range = 'range',
	Indicator = 'indicator',
}

export enum HdGraphSubType {
	Bar = 'bar',
	Area = 'area',
	Line = 'line',
	Linear = 'linear',
	Circular = 'circular',
}
